import { render } from "./IconChevronUp.vue?vue&type=template&id=1e945a97"
import script from "./IconChevronUp.vue?vue&type=script&lang=js"
export * from "./IconChevronUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__